import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CreateOrderDto } from 'src/app/domain/models/dto/create-order.dto';
import { FinalitiesDto } from 'src/app/domain/models/dto/finalities.dto';
import { FileHandle } from 'src/app/shared/directives/file-drop.directive';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-documents-order',
  templateUrl: './documents-order.component.html',
  styleUrls: ['./documents-order.component.scss'],
})
export class DocumentsOrderComponent implements OnInit {
  @Input('data') data?: CreateOrderDto;
  @Input('loading') loading?: boolean;
  @Input('finality') finality?: FinalitiesDto;
  @Output('goBack') goBack: EventEmitter<any> = new EventEmitter();
  @Output('sendFile') sendFile: EventEmitter<{
    file: FileHandle[];
    diNumber: string;
    diProtocol: string;
  }> = new EventEmitter();
  selectedFiles: FileHandle[] = [];
  diNumber = '';
  diProtocol = '';
  fileOver: boolean;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitzer: DomSanitizer,
    private readonly accountService: AuthenticationService
  ) {
    this.matIconRegistry.addSvgIcon(
      'cloud-upload',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/icons/cloud-upload.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'file',
      this.domSanitzer.bypassSecurityTrustResourceUrl(
        'assets/image/document-icon.svg'
      )
    );
  }

  filesDropped(files: FileHandle[]): void {
    this.selectedFiles = files;
  }

  selectFile(event: any) {
    this.selectedFiles.push({
      file: event.target.files[0],
      url: this.domSanitzer.bypassSecurityTrustUrl(
        window.URL.createObjectURL(event.target.files[0])
      ),
    });
  }

  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
  }

  ngOnInit(): void {}

  back() {
    this.goBack.emit(true);
  }

  submit() {
    this.sendFile.emit({
      file: this.selectedFiles,
      diNumber: this.diNumber,
      diProtocol: this.diProtocol,
    });
  }
}
